import type { MissingRef } from '@/domain/types';

/** 同一参数名只提示一次（四个电机都缺效率时不必刷屏） */
function dedupe(refs: readonly MissingRef[]): MissingRef[] {
  const seen = new Set<string>();
  const unique: MissingRef[] = [];
  for (const ref of refs) {
    if (seen.has(ref.metricKey)) continue;
    seen.add(ref.metricKey);
    unique.push(ref);
  }
  return unique;
}

/**
 * 「缺少参数“X”，未计入计算」提示。
 *
 * 只做小字提示，不弹窗、不阻塞 —— 用户可以先填一部分，随时看到当前能算出什么。
 */
export function MissingHints({
  missing,
  className = '',
}: {
  missing: readonly MissingRef[];
  className?: string;
}) {
  const unique = dedupe(missing);
  if (unique.length === 0) return null;

  return (
    <ul className={['flex flex-col gap-0.5', className].join(' ')}>
      {unique.map((ref) => (
        <li key={`${ref.componentId}:${ref.fieldKey}`} className="text-[11px] leading-relaxed text-fg-subtle">
          缺少参数
          <span className="text-caution">“{ref.fieldLabel}”</span>
          ，未计入计算
        </li>
      ))}
    </ul>
  );
}

/** 口径说明（用了估算值 / 回落数据源 / 部分求和等），与缺失提示区分开 */
export function MetricNotes({
  notes,
  className = '',
}: {
  notes: readonly string[];
  className?: string;
}) {
  if (notes.length === 0) return null;
  return (
    <ul className={['flex flex-col gap-0.5', className].join(' ')}>
      {notes.map((note, index) => (
        <li key={`${index}-${note}`} className="text-[11px] leading-relaxed text-fg-subtle">
          <span aria-hidden className="mr-1">
            ·
          </span>
          {note}
        </li>
      ))}
    </ul>
  );
}
